import { getEndpoints } from "../../Lib/Config/EndPoints/EndPoints";
import { apiRequest } from "../../Lib/Utils/ApiRequest";
import { IApiResponse } from "../../Orchestrator/Types/Index";

export async function cancelPreBooking(bookingId: string): Promise<IApiResponse<string>> {
  const ENDPOINTS = await getEndpoints();
  const endpoint = ENDPOINTS.cancelPreBookingAPI(bookingId);

  return await apiRequest<string>(endpoint, 'DELETE');
}
